import { Component } from '@angular/core';

@Component({
  selector: 'app-cerere-sabloane',
  templateUrl: './cerere-sabloane.component.html',
  styleUrls: ['./cerere-sabloane.component.scss']
})
export class CerereSabloaneComponent {

}
